<div class="flex h-full w-full flex-col gap-2 p-2">
  <sia-accordion title="Generale" [opened]="true">
    <div class="flex flex-col gap-2">
      <div class="grid grid-cols-3 gap-2">
        <sia-check-box
          label="Visibile"
          [(value)]="column.visible"
        ></sia-check-box>
        <sia-check-box
          label="Azione"
          [(value)]="column.isAction"
          (valueChanged)="isActionChange()"
        ></sia-check-box>
        <sia-check-box label="Pk" [(value)]="column.primaryKey"></sia-check-box>
        @if (column.primaryKey) {
          <sia-check-box
            label="Nascondi identificatore #"
            [(value)]="column.hidePrimaryKeyIdentifier"
          ></sia-check-box>
        }

        <sia-check-box
          label="Carica sempre"
          [(value)]="column.alwaysLoad"
        ></sia-check-box>
      </div>

      @if (!column.isAction) {
        <sia-select-box
          label="DataField"
          [(value)]="column.dataField"
          (valueChanged)="onDataFieldChange(column)"
          [selectBoxOptions]="{
            fixedDataSource: dataBaseFields,
            disableEmptyElement: true,
            value: column.dataField,
          }"
        ></sia-select-box>
        <sia-select-box
          [selectBoxOptions]="{
            fixedDataSource: gridConfFormatTypes,
            disableEmptyElement: true,
            value: column.dataType,
          }"
          [(value)]="column.dataType"
          label="Tipo"
        ></sia-select-box>
      }
      <div class="grid grid-cols-3 gap-2">
        <sia-check-box
          label="Script per Titolo"
          [(value)]="column.useScriptForCaption"
        >
        </sia-check-box>

        @if (!column.useScriptForCaption) {
          <sia-text-box
            label="Titolo"
            [(value)]="column.caption"
          ></sia-text-box>
        }
        <sia-text-box label="Tooltip" [(value)]="column.toolTip"></sia-text-box>
      </div>
      <div class="grid grid-cols-3 gap-2">
        <sia-text-box label="Larghezza" [(value)]="column.width"></sia-text-box>
        <sia-text-box
          label="Larghezza minima"
          [disabled]="!!column.width"
          [(value)]="column.minWidth"
        ></sia-text-box>
        <sia-number-box
          label="Nr. Di righe"
          [(value)]="column.rowsNumber"
        ></sia-number-box>
      </div>
      @if (!column.isAction) {
        <sia-text-box
          label="Formattazione"
          [(value)]="column.format"
        ></sia-text-box>
      }
      @if (column.dataType === 'image' || column.dataType === 'svg') {
        <div class="grid grid-cols-3 gap-2">
          <sia-text-box
            label="Altezza immagine (default 20px)"
            [(value)]="column.imageHeight"
          ></sia-text-box>
          @if (column.dataType === 'image') {
            <sia-select-box
              label="Tipo sorgente"
              [(value)]="column.imageSourceType"
              [selectBoxOptions]="{
                fixedDataSource: gridConfImageSourceTypes,
                disableEmptyElement: true,
                value: column.imageSourceType,
              }"
            ></sia-select-box>
          }
          @if (column.imageSourceType == 'path') {
            <sia-check-box
              label="Il path è relativo"
              [(value)]="column.isRelativePath"
            ></sia-check-box>
          }
        </div>
      }
      <div class="grid grid-cols-3 gap-2">
        <sia-select-box
          [selectBoxOptions]="{
            fixedDataSource: gridConfAlignmentTypes,
            disableEmptyElement: true,
            value: column.alignment,
          }"
          [(value)]="column.alignment"
          label="Allineamento"
        ></sia-select-box>
        @if (!column.isAction) {
          <sia-check-box
            label="Testo a capo"
            [(value)]="column.isFullText"
          ></sia-check-box>
          @if (column.dataType == 'string' || column.dataType == 'number') {
            <sia-check-box
              label="Traducibile"
              [(value)]="column.translate"
            ></sia-check-box>
            <sia-check-box
              label="Usa selectBox"
              [(value)]="column.useSelectBox"
            ></sia-check-box>
            @if (column.useSelectBox) {
              <sia-select-box
                label="Schema vista"
                [(value)]="column.viewSchema"
                [selectBoxOptions]="{
                  disableEmptyElement: false,
                  value: column.viewSchema,
                  dbKey: 'web.v_schemas',
                }"
              >
              </sia-select-box>
              <sia-select-box
                label="Nome vista"
                [(value)]="column.viewName"
                [selectBoxOptions]="{
                  disableEmptyElement: false,
                  value: column.viewName,
                  dbKey: 'web.v_dbobjects',
                  foreignKey: column.viewSchema,
                }"
                [foreignKey]="column.viewSchema"
              >
              </sia-select-box>
            }
          }
        }
      </div>
      @if (!column.isAction) {
        <div class="grid grid-cols-3 gap-2">
          <sia-check-box
            label="Nascondi su tablet"
            [(value)]="column.hideOnTablets"
          ></sia-check-box>
          <sia-check-box
            [(value)]="column.allowExporting"
            label="Visualizza in esportazione"
          ></sia-check-box>
          <sia-check-box
            label="Mostra in selezione colonne"
            [(value)]="column.showInColumnChooser"
          ></sia-check-box>
        </div>
        <div class="grid grid-cols-3 gap-2">
          <sia-check-box
            label="Abilita raggruppamento"
            [(value)]="column.allowGrouping"
          ></sia-check-box>
          @if (column.allowGrouping) {
            <sia-text-box
              label="Testo raggruppamento"
              [(value)]="column.groupText"
            ></sia-text-box>
          }
        </div>
      }
      @if (!column.isAction) {
        <div class="flex w-full flex-row flex-wrap gap-2">
          <sia-check-box
            [(value)]="column.allowEditing"
            label="Abilita modifica"
          ></sia-check-box>
          @if (column.allowEditing) {
            <sia-js-editor
              class="w-full"
              [(jsCode)]="column.editValidationScript"
              [title]="
                'Script validazione salvataggio (this.scriptCanContinue = true | false)'
              "
            ></sia-js-editor>
            <sia-js-editor
              class="w-full"
              [(jsCode)]="column.dataChangeValidationScript"
              [title]="'Script validazione dataChange (return messaggio)'"
            ></sia-js-editor>
          }
        </div>
      }
      @if (column.isAction) {
        <div class="grid grid-cols-3 gap-2">
          <sia-check-box
            [(value)]="column.useScriptForActionTextAndIcon"
            label="Script per Icona e Testo"
          ></sia-check-box>
          <sia-text-box
            label="Tooltip cella"
            [(value)]="column.actionTooltip"
          ></sia-text-box>
          @if (!column.useScriptForActionTextAndIcon) {
            <sia-text-box
              label="Icona"
              [(value)]="column.actionIcon"
            ></sia-text-box>
          }
          @if (!column.useScriptForActionTextAndIcon) {
            <sia-text-box
              label="Testo"
              [(value)]="column.actionText"
            ></sia-text-box>
          }
        </div>
      }
      @if (column.useScriptForCaption) {
        <div>
          <sia-js-editor
            class="w-full"
            [(jsCode)]="column.captionScript"
            [title]="'Script per Titolo'"
            [autoCompleteHints]=""
          ></sia-js-editor>
        </div>
      }
      @if (column.useScriptForActionTextAndIcon && column.isAction) {
        <sia-js-editor
          class="w-full"
          [(jsCode)]="column.actionIconScript"
          [title]="'Script per Icona'"
        ></sia-js-editor>
      }
      @if (column.useScriptForActionTextAndIcon && column.isAction) {
        <sia-js-editor
          class="w-full"
          [(jsCode)]="column.actionTextScript"
          [title]="'Script per Testo'"
        ></sia-js-editor>
      }
    </div>
  </sia-accordion>

  @if (!column.isAction) {
    <sia-accordion title="Filtro e ordinamento" [opened]="true">
      <div class="flex flex-col gap-2">
        <sia-text-box
          [(value)]="column.filterSessionParam"
          label="Nome parametro sessione"
        ></sia-text-box>
        <div class="grid grid-cols-3 gap-2">
          <sia-check-box
            [(value)]="column.allowFilter"
            label="Abilita riga filtro"
          >
          </sia-check-box>
          <mat-form-field
            appearance="outline"
            class="sia-input"
            subscriptSizing="dynamic"
            floatLabel="always"
          >
            <mat-label>{{ 'Operatore default' | siaTranslate }}</mat-label>
            <mat-select
              [disabled]="!column.allowFilter"
              [(value)]="column.defaultFilterOperation"
              panelClass="sia-mat-grid-header-filter__operator"
            >
              <mat-select-trigger>
                <div
                  [innerHtml]="
                    getFilterHtml(column.defaultFilterOperation) | safeHtml
                  "
                ></div>
              </mat-select-trigger>
              <mat-option [value]="null"> </mat-option>
              @for (
                filterType of getFiltersByType(column.dataType ?? '');
                track filterType
              ) {
                <mat-option [value]="filterType.id">
                  <div [innerHtml]="filterType.htmlContent | safeHtml"></div>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <sia-check-box
          [(value)]="column.allowHeaderFiltering"
          label="Filtro con elenco"
        >
        </sia-check-box>
        <div class="grid grid-cols-3 gap-2">
          <sia-check-box
            [(value)]="column.allowSorting"
            label="Abilita ordinamento"
          ></sia-check-box>
          <sia-number-box
            [(value)]="column.sortIndex"
            label="Priorità ordinamento"
            [disabled]="!column.allowSorting"
          ></sia-number-box>
          <sia-select-box
            label="Ordinamento"
            [(value)]="column.sortOrder"
            [selectBoxOptions]="{
              value: column.sortOrder,
              fixedDataSource: gridConfSortOrderTypes,
            }"
          ></sia-select-box>
        </div>

        <button mat-button (click)="addPrefilter()" class="w-full">
          <mat-icon>add</mat-icon> {{ 'Aggiungi prefiltro' | siaTranslate }}
        </button>
        @for (filter of column.prefilters; track filter; let index = $index) {
          <div class="surface-low flex flex-col gap-2 rounded-lg p-2">
            <mat-form-field
              class="sia-input"
              appearance="outline"
              subscriptSizing="dynamic"
            >
              <mat-label> Operatore prefiltro </mat-label>
              <mat-select
                [(value)]="filter.filterOperation"
                panelClass="sia-mat-grid-header-filter__operator"
              >
                <mat-select-trigger>
                  <div
                    [innerHtml]="
                      getFilterHtml(filter.filterOperation) | safeHtml
                    "
                  ></div>
                </mat-select-trigger>
                <mat-option [value]="null"> </mat-option>
                @for (
                  filterType of getFiltersByType(column.dataType ?? '');
                  track filterType
                ) {
                  <mat-option [value]="filterType.id">
                    <div [innerHtml]="filterType.htmlContent | safeHtml"></div>
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <sia-js-editor
              [(jsCode)]="filter.valueScript"
              [title]="'Script per valore'"
            ></sia-js-editor>
            <button
              mat-stroked-button
              (click)="removePrefilter(index)"
              class="error m-auto"
            >
              <mat-icon>delete</mat-icon> {{ 'Elimina' | siaTranslate }}
            </button>
          </div>
        }
      </div>
    </sia-accordion>
  }

  <sia-accordion title="Script" [opened]="false">
    <div class="flex flex-col gap-2">
      <sia-js-editor
        class="w-full"
        [(jsCode)]="column.scriptClickEnabled"
        [title]="'Abilita click'"
      ></sia-js-editor>
      <sia-js-editor
        class="w-full"
        [(jsCode)]="column.scriptOnClick"
        [title]="'Azione click'"
      ></sia-js-editor>
    </div>
  </sia-accordion>

  <sia-accordion title="Stile" [opened]="false">
    <div class="flex flex-col gap-2">
      <sia-check-box
        [(value)]="column.contrastColor"
        label="Colore a contrasto"
      ></sia-check-box>
      <sia-select-box
        [(value)]="column.contrastMode"
        label="Modalità contrasto"
        [selectBoxOptions]="{
          value: column.contrastMode,
          fixedDataSource: gridConfContrastModeTypes,
        }"
      ></sia-select-box>
      <button mat-button (click)="addStyle()" class="w-full">
        <mat-icon>add</mat-icon> {{ 'Aggiungi stile' | siaTranslate }}
      </button>

      @for (style of column.styleConditions; track style; let index = $index) {
        <div class="surface-low flex flex-col gap-2 rounded-lg p-2">
          <sia-js-editor
            [(jsCode)]="style.cssStyleCondition"
            [title]="'Condizione'"
          ></sia-js-editor>
          <sia-css-editor
            [(cssCode)]="style.cssStyle"
            [title]="'Stile css'"
          ></sia-css-editor>
          <button
            mat-stroked-button
            (click)="removeStyle(index)"
            class="error m-auto"
          >
            <mat-icon>delete</mat-icon> {{ 'Elimina' | siaTranslate }}
          </button>
        </div>
      }
    </div>
  </sia-accordion>
  @if (!column.isAction) {
    <sia-accordion title="Totalizzazione" [opened]="false">
      <div class="flex flex-col gap-2">
        <div class="grid grid-cols-3 gap-2">
          <sia-check-box
            label="Abilita totalizzazione"
            [(value)]="column.summaryColEnable"
          ></sia-check-box>
          <sia-select-box
            [disabled]="!column.summaryColEnable"
            [(value)]="column.summaryType"
            label="Calcolo"
            [selectBoxOptions]="{
              value: column.summaryType,
              fixedDataSource: summaryTypes,
            }"
          ></sia-select-box>
          <sia-text-box
            label="Campo per totalizzazione"
            [(value)]="column.summaryDataField"
            [statusMessages]="fieldSummaryColumnMessage"
            [disabled]="!column.summaryColEnable"
          >
          </sia-text-box>

          <sia-text-box
            [disabled]="!column.summaryColEnable"
            [(value)]="column.summaryDisplayFormat"
            label="Formato"
          ></sia-text-box>
        </div>
        <sia-js-editor
          [readOnly]="!column.summaryColEnable"
          [(jsCode)]="column.summaryScript"
          title="Script formato"
        ></sia-js-editor>
      </div>
    </sia-accordion>
  }
  <sia-accordion title="Layout Excel" [opened]="false">
    <div class="flex flex-col gap-2">
      <div class="grid grid-cols-3 gap-2">
        <sia-select-box
          [(value)]="column.excelConfiguration!.alignText"
          label="Allineamento"
          [selectBoxOptions]="{
            value: column.excelConfiguration!.alignText,
            fixedDataSource: gridConfAlignmentTypes,
          }"
        ></sia-select-box>
        <sia-check-box
          label="Testo a capo"
          [(value)]="column.excelConfiguration!.isWrapText"
        ></sia-check-box>
        <sia-number-box
          [disabled]="!column.excelConfiguration!.isWrapText"
          [(value)]="column.excelConfiguration!.colWidth"
          label="Dimensione colonna"
        ></sia-number-box>
        <sia-color-box
          [(value)]="column.excelConfiguration!.colColor"
          label="Colore testata"
        ></sia-color-box>
        @if (column.dataField == '') {
          <sia-text-box
            [(value)]="column.excelConfiguration!.formulaCell"
            [placeholder]="'es. =INDIRECT(@countryid@&ROW())'"
            label="Formula cella"
          ></sia-text-box>
        }
        @if (column.dataType == 'number') {
          <sia-number-box
            [(value)]="column.excelConfiguration!.decimalPlaces"
            label="Decimali"
          >
          </sia-number-box>
        }
      </div>

      <button mat-button (click)="addFormat()" class="w-full">
        <mat-icon>add</mat-icon> {{ 'Aggiungi formattazione' | siaTranslate }}
      </button>

      @for (
        format of column.excelConfiguration?.formatting;
        track format;
        let index = $index
      ) {
        <div class="surface-low flex flex-col gap-2 rounded-lg p-2">
          <sia-text-box
            [(value)]="format!.formula"
            placeholder="{{
              'es. =INDIRECT(@countryid@&ROW())=&quot;IT&quot;'
            }}"
            label="Formula"
          ></sia-text-box>
          <sia-color-box label="Colore Background" [(value)]="format!.bgColor">
          </sia-color-box>
          <sia-color-box label="Colore testo" [(value)]="format!.textColor">
          </sia-color-box>
          <button
            mat-stroked-button
            (click)="removeFormat(index)"
            class="error m-auto"
          >
            <mat-icon>delete</mat-icon> {{ 'Elimina' | siaTranslate }}
          </button>
        </div>
      }
    </div>
  </sia-accordion>
</div>
